module.exports = __webpack_public_path__ + "static/media/team-pascal.0f44f05a.jpg";